import React from "react";
import { SettingRow } from "../SettingRow";
import { Text } from "../../../../../../common/components/input/Text";
import { INFORMATIONAL_BANNER_TITLE_DEFAULT_TEXT } from "../../../../superorg/settings/ConsentBannerSettings";

interface ConsentBannerTitleRowProps {
  formApi: { change: (field: string, value: string) => void };
  canadaBannerEnabled?: boolean;
}

/* We can only allow customizing this title text in the US since other regions have a language selector */
export const ConsentBannerUSTitleRow = ({ formApi }: ConsentBannerTitleRowProps) => {
  return (
    <SettingRow
      maxWidthChildren={true}
      title={`Banner Title`}
      helpText="Customize the consumer-friendly banner title that will appear at the top of the banner. This applies only for opt-in and opt-out banners (non-GDPR)."
    >
      <Text
        className="w-100 mb-sm"
        fullWidth={false}
        field="informationalBannerTitle"
        variant="outlined"
        helperText=""
        required
        inputProps={{ maxLength: 64 }}
      />
      <div>
        <a
          onClick={(e) => {
            e.preventDefault();
            formApi.change("informationalBannerTitle", INFORMATIONAL_BANNER_TITLE_DEFAULT_TEXT);
          }}
          href="#"
        >
          Set to Default Text
        </a>
      </div>
    </SettingRow>
  );
};
